export default __webpack_public_path__ + "static/media/imgActivity8-3.6f285356.png";